import { createContext } from "react";
import type { Feed } from "../hooks/useCatalog";

/** The live pricing feed, when the page has it. The prerender has none and
    falls back to the prices in data/games.tsx, as every other page does.
    Its own file so parts.tsx exports only components. */
export const FeedContext = createContext<Feed | null>(null);
